import { v4 as uuidv4 } from 'uuid';
import { SimpleUser } from './user';

export interface Note {
    id: uuidv4;
    projectName: string;
    projectCode?: string;
    projectId?: string;
    bidId?: string;
    userId?: string;
    name?: string;
    img?: File;
    message: string;
    isExternalEmail?: Boolean;
    externalEmailFrom: string;
    partnerId?: string;
    cDate: Date;
    uDate: Date;
    tags?: Tags[];
    subject?: string;
    title?: string;
    partnerName?: string;
    nameOfUserWhoCreatedNote?: string;
    time?: string;
    noteType: NoteType;
    userType?: string;
    clientId?: string;
    taggedUsers?: Array<string>;
    replies?: any[];
    reactions?: Reaction[];
    attachments?: NoteAttachment[];
}

// A file or link on a project note; it is also filed in the project's Project Folder.
// `id` is empty until the note is saved, and `url` is only returned for links.
export interface NoteAttachment {
    id?: string;
    fileName: string;
    url?: string;
    assetType: 'file' | 'link';
}

export interface Tags {
    id: uuidv4;
    tag: string;
}

export enum NoteType {
    FieldNote = 0,
    ScreeningCriteria = 1
}

export interface Reaction {
    type: string;
    reactedBy: SimpleUser[];
    reactedByMe: boolean;
}

